const srcSizes = [
  360,
  375,
  414,
  640,
  720,
  750,
  768,
  828,
  1024,
  1080,
  1125,
  1242,
  1280,
  1536,
  1920,
  2000,
]
const thumbnailSizes = [
  360, 
  // 375,
  // 414,
]
const gridSizes = [
  360, 
  // 375,
  // 414,
  640, // Stays for 2 iPhones (@2x, 2 items per grid col, up to 213px each, screen size up to 474px)
  // 720,
  // 750,
  // 768,
  // 828,
  // 1024,
  1080, // Stays for 767px screen size, (@3x, 2 items per grid col, 360px each)
  // 1125,
  // 1242,
  // 1280,
  1536, // 1024/2 = 512 (2 items per grid col) * 3(DPR); 1536/3 = 512 (3 items per grid col) * 3(DPR)

  // 414px screen size
  // grid size: 414px - 40px (outer padding): 374px 
  // column size: 374px - 20px (gap beween columns) = 355px / 2 = 177px
  //
  // md-size, i.e. 1023px screen size
  // w-10/12 mx-auto: container size: 1023px * 10/12 = 852px
  // grid size: 852px - 40px (outer padding): 812px 
  // column size: 812px - 20px (gap beween columns) = 792px / 2 = 396px 
  // image size: 396px - 40px (inner padding) = 356px -> this is the image width  ; max size when 2 items per grid col
]

const reversedSrcSizes = [...srcSizes].reverse()

const IMAGE_TYPES = {
  regular: '-w',
  square: '-s'
}
const getImageSize = (item, size, format, type=IMAGE_TYPES.regular) => {
  const { width, height, url, ext } = item.gatsbyImageDataMock
  let imageSize = width > height ? width : height
  const sizes = reversedSrcSizes.filter(s => s <= size && size <= imageSize)
  if (sizes.length === 0) return url
  size = sizes[0]
  switch(format)
  {
    case 'avif':
      return url.replace('/o/', '/s/').replace(ext, `${type}${size}${ext}.avif`)
    case 'webp':
      return url.replace('/o/', '/s/').replace(ext, `${type}${size}${ext}.webp`)
    case 'jpg':
    case 'jpeg':
      return url.replace('/o/', '/s/').replace(ext, `${type}${size}${ext}`)
    default:
      return url.replace('/o/', '/s/').replace(ext, `${type}${size}${ext}.auto`)
  }
}
const getGatsbyImageData = ({ width, height, url, ext  }, sizes=srcSizes, imageSizes='100vw') => {
  // get the CDN image url for all src sets
  // let's get the image width
  const _sizes = imageSizes// TODO: consider making it fit better the layout options
  let srcsetWebp = ''
  let srcsetAvif = ''
  let srcset = ''
  let first = true
  let imageSize = width > height ? width : height
  for (const size of sizes) {
    if (size >= imageSize && !first) break
    first = false
    srcset += url.replace('/o/', '/s/').replace(ext, `-w${size}${ext}.auto ${size}w, `)
    srcsetWebp += url.replace('/o/', '/s/').replace(ext, `-w${size}${ext}.webp ${size}w, `)
    srcsetAvif += url.replace('/o/', '/s/').replace(ext, `-w${size}${ext}.avif ${size}w, `)
  }
  // remove the last comma and space
  srcset = srcset.slice(0, -2)
  srcsetWebp = srcsetWebp.slice(0, -2)
  srcsetAvif = srcsetAvif.slice(0, -2)
  const fallbackUrl = url.replace('/o/', '/s/').replace(ext, `-w${360}${ext}.auto`)
  return {
    layout: 'constrained',
    backgroundColor: '#FFFFFF', // placeholder: {
    //   children: <IconLoaders />,
    //   className: 'm-1',
    // },
    images: {
      fallback: {
        src: fallbackUrl,
        srcSet: srcset,
        sizes: _sizes,
      },
      sources: [
        {
          srcSet: srcsetAvif,
          type: 'image/avif',
          sizes: _sizes,
        },
        {
          srcSet: srcsetWebp,
          type: 'image/webp',
          sizes: _sizes,
        },
      ],
    },
    width: width,
    height: height,
  }
}
const processGatsbyImageDataMock = (item, sizes=srcSizes) => {
  if(!item) return item
  if (item?.gatsbyImageData) return item
  if (!item?.gatsbyImageDataMock) return item
  const { width, height, url, ext } = item.gatsbyImageDataMock
  item.gatsbyImageData = getGatsbyImageData({ width, height, url, ext }, sizes)
  return item
}

module.exports = { getGatsbyImageData, srcSizes, reversedSrcSizes, gridSizes, thumbnailSizes, processGatsbyImageDataMock, getImageSize, IMAGE_TYPES }
